import { useState, useEffect, useMemo } from "react";
import { Loading } from "../../components";
import banner1 from "./assets/001.jpg";
import banner2 from "./assets/002.jpg";
import banner3 from "./assets/003.jpg";
import banner4 from "./assets/004.jpg";
import banner5 from "./assets/005.jpg";
import banner6 from "./assets/006.jpg";
import banner7 from "./assets/007.jpg";
import banner8 from "./assets/008.jpg";
import banner9 from "./assets/009.jpg";
import banner10 from "./assets/010.jpg";
import banner11 from "./assets/011.jpg";
import banner12 from "./assets/012.jpg";
import banner13 from "./assets/013.jpg";
import banner14 from "./assets/014.jpg";
import banner15 from "./assets/015.jpg";
import banner16 from "./assets/016.jpg";
import banner17 from "./assets/017.jpg";
import banner18 from "./assets/018.jpg";
import banner19 from "./assets/019.jpg";
import banner20 from "./assets/020.jpg";
import banner21 from "./assets/021.jpg";
import banner22 from "./assets/022.jpg";
import banner23 from "./assets/023.jpg";
import banner24 from "./assets/024.jpg";
import banner25 from "./assets/025.jpg";
import banner26 from "./assets/026.jpg";
import banner27 from "./assets/027.jpg";
import banner28 from "./assets/028.jpg";
import banner29 from "./assets/029.jpg";
import banner30 from "./assets/030.jpg";
import banner31 from "./assets/031.jpg";
import banner32 from "./assets/032.jpg";
import banner33 from "./assets/033.jpg";
import banner34 from "./assets/034.jpg";
import banner35 from "./assets/035.jpg";
import banner36 from "./assets/036.jpg";

export const Installation = () => {
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [carouselOpen, setCarouselOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const images = useMemo(
    () => [
      banner22,
      banner2,
      banner3,
      banner4,
      banner5,
      banner6,
      banner7,
      banner8,
      banner9,
      banner10,
      banner11,
      banner12,
      banner13,
      banner14,
      banner15,
      banner16,
      banner17,
      banner18,
      banner19,
      banner20,
      banner21,
      banner23,
      banner24,
      banner25,
      banner26,
      banner27,
      banner28,
      banner29,
      banner30,
      banner31,
      banner32,
      banner33,
      banner34,
      banner35,
      banner36,
      banner1,
    ],
    []
  );

  const openImage = (image: any, index: any) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
    setCarouselOpen(true);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setCarouselOpen(false);
  };

  const nextImage = () => {
    if (carouselOpen) {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (carouselOpen) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    }
  };

  useEffect(() => {
    const imagePromises = images.map((imageSrc) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = imageSrc;
      });
    });

    Promise.all(imagePromises)
      .then(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error loading images:", error);
        setIsLoading(false);
      });
  }, [images]);

  useEffect(() => {
    if (carouselOpen) {
      setSelectedImage(images[currentImageIndex]);
    }
  }, [currentImageIndex, carouselOpen, images]);

  // useEffect(() => {
  //   let intervalId: any;

  //   if (carouselOpen) {
  //     intervalId = setInterval(() => {
  //       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //     }, 3000);
  //   }
  //   return () => clearInterval(intervalId);
  // }, [carouselOpen, images.length]);

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <section className="relative h-screen flex items-center justify-center">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
            <div className="absolute inset-0">
              <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
              <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
            </div>
            <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
                style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
              >
                INSTALAÇÕES
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
                Conheça nossa estrutura completa projetada para proporcionar
                conforto e recuperação.
              </p>

              <div className="animate-bounce-gentle mb-8">
                <svg
                  className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                  />
                </svg>
              </div>
            </div>
          </section>

          {/* Description Section */}
          <section className="py-20 bg-white text-brand-blue">
            <div className="max-w-7xl mx-auto px-4">
              <div className="text-center mb-16">
                <h2 className="text-5xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
                  Nossa Estrutura
                </h2>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-3xl shadow-xl max-w-4xl mx-auto">
                  <p className="text-xl font-roboto text-gray-700 leading-relaxed mb-6">
                    A Comunidade Terapêutica fica localizada numa área de 7,5ha,
                    rural.
                  </p>
                  <p className="text-xl font-roboto text-gray-700 leading-relaxed">
                    Tem capacidade para acolher 25 adultos, do sexo masculino,
                    com idades entre 18 a 59 anos.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Gallery */}
          <section className="py-20 bg-gradient-to-r from-slate-800 to-slate-900">
            <div className="max-w-7xl mx-auto px-4">
              <h2 className="text-5xl font-bold text-center font-montserrat mb-16 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
                Galeria de Fotos
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {images.map((image, index) => (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105 cursor-pointer"
                    onClick={() => openImage(image, index)}
                  >
                    <img
                      src={image}
                      alt={`Instalação ${index + 1}`}
                      className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                      <span className="text-white font-montserrat font-bold text-lg">
                        Ver imagem completa
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Modal */}
          {selectedImage && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
              onClick={closeImage}
            >
              <div className="relative max-w-5xl max-h-[90vh] p-4">
                <button
                  className="absolute -top-12 right-0 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 z-60"
                  onClick={closeImage}
                >
                  ×
                </button>

                <button
                  className="fixed left-4 top-1/2 -translate-y-1/2 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 bg-black/50 rounded-full w-14 h-14 flex items-center justify-center z-[9999]"
                  onClick={(event) => {
                    prevImage();
                    event.stopPropagation();
                  }}
                >
                  ‹
                </button>

                <button
                  className="fixed right-4 top-1/2 -translate-y-1/2 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 bg-black/50 rounded-full w-14 h-14 flex items-center justify-center z-[9999]"
                  onClick={(event) => {
                    nextImage();
                    event.stopPropagation();
                  }}
                >
                  ›
                </button>

                <img
                  src={selectedImage}
                  alt="Imagem ampliada"
                  className="max-w-full max-h-full object-contain rounded-2xl shadow-2xl"
                />

                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 xl-custom:flex space-x-2 hidden">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        index === currentImageIndex
                          ? "bg-brand-yellow"
                          : "bg-white/50"
                      }`}
                      onClick={(event) => {
                        setCurrentImageIndex(index);
                        event.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
